import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DefaultFrameComponent } from '../../../frames/default-frame/default-frame.component';

@Component({
    selector: 'kaz-conditions',
    templateUrl: './conditions.component.html',
    styleUrls: ['./conditions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent]
})
export class ConditionsComponent {

}
